export default class ControlMessage {
  constructor(t, s) {
    (this.triggerId = t),
      (this.messageExtras = s),
      (this.triggerId = t),
      (this.messageExtras = s),
      (this.extras = {}),
      (this.isControl = !0);
  }
  static fromJson(t) {
    return new ControlMessage(t.trigger_id, t.message_extras);
  }
}
